import { useState, useEffect } from 'react';

export const useIsMobile = (width = 1024) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= width);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= width);
    };

    window.addEventListener('resize', handleResize);
    // Cleanup: Bileşen kapandığında dinleyiciyi kaldır
    return () => window.removeEventListener('resize', handleResize);
  }, [width]);

  return isMobile;
};